import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "voucher-code-verify-wrap"
};
var _hoisted_2 = {
  class: "select-coupon-list-wrap"
};
var _hoisted_3 = {
  key: 1,
  class: "empty-view"
};
import Common from "@/components/dialog/src/Common.vue";
import { computed, nextTick, ref, watch } from "vue";
import SelectCouponItem from "./SelectCouponItem.vue";
import { useCartStore } from "@/store/cartStore";
import { useI18n } from "vue-i18n";
import VoucherCodeVerify from "./VoucherCodeVerify.vue";
import VoucherCodeItem from "./VoucherCodeItem.vue";
import { useSupplierStore } from "@/store/supplierStore";
import { Notify } from "@/utils/notifyUtil";
export default {
  __name: 'SelectCouponList',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    couponList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isNotNeedVoucherCode: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var cartStore = useCartStore();
    var props = __props;
    var emits = __emit;
    var showSelectCouponList = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emits("update:show", val);
      }
    });
    var voucherCodeDetail = ref(null);
    var voucherCodeRef = ref();
    var tempSelectCoupon = ref(null);
    var tempSelectVoucherCode = ref(null);
    function selectCoupon(couponItem) {
      if (tempSelectCoupon.value && tempSelectCoupon.value.id === couponItem.id) {
        tempSelectCoupon.value = null;
      } else if (!couponItem.cannot_use) {
        tempSelectCoupon.value = couponItem;
        tempSelectVoucherCode.value = null;
      }
    }
    function selectVoucherCode(voucherCodeItem) {
      if (tempSelectVoucherCode.value && tempSelectVoucherCode.value.card_number === voucherCodeItem.card_number) {
        tempSelectVoucherCode.value = null;
      } else {
        tempSelectVoucherCode.value = voucherCodeItem;
        tempSelectCoupon.value = null;
      }
    }
    // 校验礼品卡成功，则选择该礼品卡并确认
    function verifyVoucherCode(voucherCodeItem) {
      cartStore.setVoucherCodeDetail(voucherCodeItem);
      selectVoucherCode(voucherCodeItem);
      handleConfirm();
    }
    function handleConfirm() {
      if (props.isNotNeedVoucherCode && tempSelectVoucherCode.value) {
        Notify.warn(t("pointsAndVoucherCodeCannotUseTogether"));
        return;
      }
      if (tempSelectCoupon.value) {
        cartStore.setCoupon(tempSelectCoupon.value);
        cartStore.setVoucherCode(null);
      } else {
        cartStore.setCoupon(null);
      }
      if (tempSelectVoucherCode.value) {
        cartStore.setVoucherCode(tempSelectVoucherCode.value);
        cartStore.setCoupon(null);
      } else {
        cartStore.setVoucherCode(null);
      }
      showSelectCouponList.value = false;
    }
    var okText = computed(function () {
      return tempSelectCoupon.value || tempSelectVoucherCode.value ? t("useThisVoucher") : t("notUseVoucher");
    });
    var selectCouponListContainerRef = ref();
    watch(showSelectCouponList, function (val) {
      if (val) {
        tempSelectCoupon.value = null;
        tempSelectVoucherCode.value = null;
        voucherCodeDetail.value = null;
        if (cartStore.getCoupon) {
          tempSelectCoupon.value = cartStore.getCoupon;
        }
        if (cartStore.getVoucherCode) {
          tempSelectVoucherCode.value = cartStore.getVoucherCode;
        }
        if (cartStore.getVoucherCodeDetail) {
          voucherCodeDetail.value = cartStore.getVoucherCodeDetail;
        }
        // 滚动到顶部
        if (selectCouponListContainerRef.value) {
          nextTick(function () {
            selectCouponListContainerRef.value.scrollTop = 0;
          });
        }
      } else {
        var _voucherCodeRef$value;
        (_voucherCodeRef$value = voucherCodeRef.value) === null || _voucherCodeRef$value === void 0 || _voucherCodeRef$value.reset();
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Common, {
        visible: showSelectCouponList.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return showSelectCouponList.value = $event;
        }),
        "ok-text": okText.value,
        "without-cancel": "",
        "show-close-btn": "",
        title: _ctx.$t('selectAVoucher'),
        "on-ok": handleConfirm
      }, {
        content: _withCtx(function () {
          var _unref$getGiftCardSet, _tempSelectVoucherCod;
          return [_createElementVNode("div", {
            ref_key: "selectCouponListContainerRef",
            ref: selectCouponListContainerRef,
            class: "select-coupon-list-container"
          }, [(_unref$getGiftCardSet = _unref(supplierStore).getGiftCardSetting) !== null && _unref$getGiftCardSet !== void 0 && _unref$getGiftCardSet.is_open ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(VoucherCodeVerify, {
            ref_key: "voucherCodeRef",
            ref: voucherCodeRef,
            "is-not-need": __props.isNotNeedVoucherCode,
            onVerify: verifyVoucherCode
          }, null, 8, ["is-not-need"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [voucherCodeDetail.value || __props.couponList.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [voucherCodeDetail.value ? (_openBlock(), _createBlock(VoucherCodeItem, {
            key: 0,
            class: "voucher-code-item",
            "voucher-code-item": voucherCodeDetail.value,
            "selected-card-number": ((_tempSelectVoucherCod = tempSelectVoucherCode.value) === null || _tempSelectVoucherCod === void 0 ? void 0 : _tempSelectVoucherCod.card_number) || '',
            onSelect: _cache[0] || (_cache[0] = function ($event) {
              return selectVoucherCode(voucherCodeDetail.value);
            })
          }, null, 8, ["voucher-code-item", "selected-card-number"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.couponList, function (item) {
            var _tempSelectCoupon$val;
            return _openBlock(), _createBlock(SelectCouponItem, {
              key: item.id,
              class: "select-coupon-item",
              "coupon-item": item,
              "selected-id": ((_tempSelectCoupon$val = tempSelectCoupon.value) === null || _tempSelectCoupon$val === void 0 ? void 0 : _tempSelectCoupon$val.id) || '',
              onSelect: function onSelect($event) {
                return selectCoupon(item);
              }
            }, null, 8, ["coupon-item", "selected-id", "onSelect"]);
          }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("noVouchersYet")), 1))])], 512)];
        }),
        _: 1
      }, 8, ["visible", "ok-text", "title"]);
    };
  }
};